import type { JSX } from 'react'

export const HeartIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <g>
    <use
      href='#heartSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
    <use href='#heartIcon' height='100%' width='100%' />
  </g>
)
